module.exports = __webpack_public_path__ + "static/img--ad--instagram-c8ea9783eb5c2f5dbe8d4353c003c18b.png";